export const PAGES_QTDE = [
    {
        label: "10 / páginas",
        value: 10
    },
    {
        label: "20 / páginas",
        value: 20
    },
    {
        label: "50 / páginas",
        value: 50
    },
    {
        label: "100 / páginas",
        value: 100
    },
];

export const FULLSCREEN_LAYER_Z_INDEX = 10000;
export const SELECT_POPUP_Z_INDEX = FULLSCREEN_LAYER_Z_INDEX + 50;

export function formatarData(dataISO: string) {
  return new Date(dataISO).toLocaleDateString('pt-BR', {
    timeZone: 'UTC'
  });
}